import React from "react";
import { OngoingOrderDisplay } from "./OngoingOrderDisplay";
import { OngoingVendorOrderDisplay } from "./OngoingVendorOrderDisplay";

/**
 * Unified component that displays ongoing orders for both buyers and vendors
 * Shows buyer orders for all users (everyone can be a buyer)
 * Additionally shows vendor orders if user is also a vendor
 * Both components will only render if they have ongoing orders to display
 * 
 * Note: Uses React Fragment to prevent empty container affecting layout
 * when both child components return null
 */
export const OngoingOrdersDisplay: React.FC = () => {
  return (
    <>
      {/* Always show buyer orders - everyone can be a buyer */}
      <OngoingOrderDisplay />

      {/* Additionally show vendor orders if user is a vendor */}
      <OngoingVendorOrderDisplay />
    </>
  );
};
